export default "__VITE_ASSET__SYO7Cn4R__"